import React from "react";

import { ValidationDashboardTable } from "./validationDashboardTable/ValidationDashboardTable";

export const DashboardTabContent: React.FC = () => {
  return (
    <div data-testid="dashboard-tab-content">
      <ValidationDashboardTable />
    </div>
  );
};

export default DashboardTabContent;
